import { AudioManager } from './audio/AudioManager';
import { InputManager } from './input/InputManager';
import { SaveStore } from './sim/save';

export const saveStore = new SaveStore(window.localStorage);
export const audioManager = new AudioManager();
export const inputManager = new InputManager(saveStore.data.settings.controls);

audioManager.setVolumes(saveStore.data.settings.musicVolume, saveStore.data.settings.sfxVolume);
